module.exports = __webpack_public_path__ + "static/media/ic-linkedin.ce1d3e63.svg";